var animations = [];
var scrolltrigger = [];
var timer = [];
var sections = [];
var animated_content = [];

// ALGEMEINE TRANSITIONS

if ($('.scrolltrigger').length > 0) {

    $('.scrolltrigger').each(function build_scrolltrigger(idx) {

        let parent_id = $(this).attr("id");
        let background = $(this).attr("data-background");
        let old_color_scheme = $('#main_nav').attr("data-colorscheme");

        let my_timer = 300;
        let my_duration = 10;
        let my_duration_reset = 20;

        let my_start;
        let my_end;

        let offsetLeft;

        let is_anchor;
        let is_default;


        // POSITION
        if ($('#' + parent_id).hasClass("scrolltrigger_anchor")) {
            my_start = "top-=100 top";
            my_end = "bottom top";
            is_anchor = true;
        } else {
            // DEFAULT
            // Activate media at the page top as well (ScrollTrigger start is exclusive).
            my_start = $(this).hasClass("scrolltrigger_image_background") ? "top top+=1" : "top top";
            my_end = "bottom top";
            is_default = true;
        }


        scrolltrigger[idx] = ScrollTrigger.create({
            // Hero videos may be inset by a border; use the actual hero boundary.
            trigger: $(this).hasClass('hero_video_video') ? $(this).closest('.hero_video')[0] : '#' + parent_id,
            start: my_start,
            end: my_end,
            invalidateOnRefresh: true,
            scrub: true,
            onToggle: (self) => {

                // SCROLLTRIGGER TOGGLED TO ACTIVE

                if (self.isActive == true) {

                    // IF IS IMAGE

                    if ($('#' + parent_id).hasClass("scrolltrigger_image_background")) {

                        if ($('#' + parent_id).get(0).tagName == "img") {
                            offsetLeft = $('#' + parent_id).offsetLeft;
                        } else {
                            offsetLeft = $('#' + parent_id).parent()[0].offsetLeft;
                        }

                        if ((window.innerWidth - offsetLeft - $('#' + parent_id).width()) < $('#main_nav').width()) {
                            $('#main_nav').attr("data-colorscheme", background);
                        }

                    } else if ($('#' + parent_id).hasClass("scrolltrigger_anchor")) {

                        if ($('#menu-hauptmenue li a[href="' + root_url + '#' + parent_id + '"]').length > 0) {
                            $('#menu-hauptmenue li').removeClass("hover");
                            $('#menu-hauptmenue li a[href="' + root_url + '#' + parent_id + '"]').parent().addClass("hover");
                        }

                    } else {
                        // COLOR CHANGE
                        // console.log("color-change: " + background);
                        $('#main_nav').attr("data-colorscheme", background);
                        // console.log("default toggled to active");
                    }


                } else {

                    // SCROLLTRIGGER TOGGLED TO PASSIVE

                    // RESTORE PREVIOUS COLORSCHEME FOR IMAGES
                    if ($('#' + parent_id).hasClass("scrolltrigger_image_background")) {
                        $('#main_nav').attr("data-colorscheme", old_color_scheme);
                    } else {
                        // console.log("default toggled to passive");
                    }

                }
            },
            onUpdate: (self) => {


            }
        });
    });
}


if ($('.animated_content').length > 0) {
    $('.animated_content').each(function (idx) {

        let parent_id = $(this).attr("id");

        animated_content[idx] = ScrollTrigger.create({
            trigger: '#' + parent_id + '',
            start: "top bottom",
            end: "bottom top",
            invalidateOnRefresh: true,
            scrub: true,

            onUpdate: (self) => {

                if (self.isActive == true) {

                    // console.log("section " + parent_id + " update");


                    let transition_down = ((self.progress.toFixed(12) * 100) * scroll_down_multiplier) / transition_factor ;

                    let transition_up = ((self.progress.toFixed(12) * 100) * scroll_up_multiplier) / transition_factor ;

                    if(self.direction == 1) {
                        // scroll down
                        transition = transition_down;
                    } else {
                        // scroll up
                        transition = transition_up;
                    }



                    if ($('#' + parent_id).hasClass("reset")) {
                        $('#' + parent_id).removeClass("reset");
                    }


                    $('#' + parent_id).css({
                        'transform': 'translateY(' + transition + 'rem)'
                    });

                    clearTimeout(timer[idx]);

                    timer[idx] = setTimeout(() => {

                        // console.log("timeout reached for " + parent_id);

                        if (!$('#' + parent_id).hasClass("reset")) {
                            $('#' + parent_id).addClass("reset");                           
                        }


                        setTimeout(() => {
                            $('#' + parent_id).css({
                                'transform': 'translateY(0rem)'
                            });
                        }, 10);





                    }, 200 );


                }


            }
        });

    });
}


// TOGGLE LOGO ON SCROLL

const logoScrollThreshold = 80; // Pixels travelled in the same direction.
const fixedLogo = $('#logo_fixed');
const logoFooter = document.getElementById('footer_bracket');
let logoPreviousScrollPos = Math.max(0, window.pageYOffset);
let logoScrollDirection = 0;
let logoScrollDistance = 0;

const storeScroll = () => {
    const currentScrollPos = Math.max(0, window.pageYOffset);
    const delta = currentScrollPos - logoPreviousScrollPos;
    logoPreviousScrollPos = currentScrollPos;
    $('body').attr('data-scroll', currentScrollPos);

    if (!fixedLogo.length) return;

    const inFooter = logoFooter && logoFooter.getBoundingClientRect().top <= window.innerHeight;

    if (inFooter) {
        fixedLogo.removeClass('visible').hide();
        logoScrollDirection = 0;
        logoScrollDistance = 0;
        return;
    }

    fixedLogo.show();

    // Always restore the initial state when returning to the top.
    if (currentScrollPos === 0) {
        fixedLogo.addClass('visible');
        logoScrollDirection = 0;
        logoScrollDistance = 0;
        return;
    }
    if (delta === 0) return;

    const direction = delta > 0 ? 1 : -1;
    if (direction !== logoScrollDirection) {
        logoScrollDirection = direction;
        logoScrollDistance = 0;
    }
    logoScrollDistance += Math.abs(delta);

    if (logoScrollDistance >= logoScrollThreshold) {
        fixedLogo.toggleClass('visible', direction === -1);
        logoScrollDistance = 0;
    }
};

const debounce = (fn) => {
    let frame;
    return (...params) => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => fn(...params));
    };
};

function addScrollListener() {
    const updateScroll = debounce(storeScroll);
    document.addEventListener('scroll', updateScroll, { passive: true });
    window.addEventListener('resize', updateScroll);
    window.addEventListener('load', updateScroll);
    window.addEventListener('pageshow', updateScroll);

    // Recheck boundaries when images, fonts or expandable content change layout.
    if (fixedLogo.length && typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(updateScroll);
        [document.querySelector('main'), logoFooter].forEach((element) => {
            if (element) observer.observe(element);
        });
    }
    storeScroll();
}

addScrollListener();
